import {InjectionToken} from "@angular/core";

export const BASE_HREF = new InjectionToken<string>('baseHref');
